import { ConfigService } from '../../../../services';
import { OrderConfig } from '../../../../dto/order-config';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OnInit, Component } from '@angular/core';
import { OrderEmailTemplatesService } from '../../../services/order-email-templates.service';
import { EmailTemplate } from '../../../../dto/templates/email-template';
import {TotalCardOrderEmailTemplatesService} from '../../../services/total-card-order-email-templates.service';
import {TotalCardOrderConfig} from '../../../../dto/total-card-order-config';

@Component({
  selector: 'app-total-card-order-config',
  templateUrl: './total-card-order-config.component.html',
  styleUrls: ['./total-card-order-config.component.css']
})
export class TotalCardOrderConfigComponent implements OnInit {
  emailTemplates: EmailTemplate[];

  constructor(
    private configService: ConfigService,
    private formBuilder: FormBuilder,
    private emailTemplatesService: TotalCardOrderEmailTemplatesService,
  ) { }

  configForm: FormGroup;

  ngOnInit() {
    this.emailTemplatesService.getMany().subscribe(result => {
      this.emailTemplates = result.data;
      this.configService.getTotalCardOrderConfig().subscribe(data => {
        this.initForm(data);
      });
    });
  }

  initForm(value: TotalCardOrderConfig = null) {
    if (value != null) {
      this.configForm = this.formBuilder.group({
        totalCardOrderConfirmationTemplateId:    [value.totalCardOrderConfirmationTemplateId, Validators.required]
      });
    }
    this.configForm.markAsPristine();
  }

  onSubmit(form: FormGroup) {
    this.configService.setTotalCardOrderConfig(form.value).subscribe(result => {
      this.initForm();
    });
  }
}
